import React from 'react'

import { Badge } from '../Badge'
import { BIRTHDAY_SCHEMA as txt } from '../BadgeContent'
import { useHostCustomer } from '../../../../hooks/useHostCustomer'

function BirthdayBadge(): JSX.Element {
  const { hostLoading } = useHostCustomer()

  return (
    <Badge
      status={hostLoading}
      icon={txt.icon.DEFAULT}
      heading={txt.heading.DEFAULT}
      desc={txt.desc.DEFAULT}
    />
  )
}

export { BirthdayBadge }
